module.exports = __webpack_public_path__ + "img/alarm.2755a86c.png";